'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reflux = require('reflux');

var _reflux2 = _interopRequireDefault(_reflux);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _MainStore = require('../stores/MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

var _CartStore = require('../stores/CartStore');

var _CartStore2 = _interopRequireDefault(_CartStore);

var _Utility = require('../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _StyleGenerator = require('../utils/StyleGenerator');

var _StyleGenerator2 = _interopRequireDefault(_StyleGenerator);

var _CategoryMenu = require('./CategoryMenu');

var _CategoryMenu2 = _interopRequireDefault(_CategoryMenu);

var _Actions = require('../Actions');

var _Actions2 = _interopRequireDefault(_Actions);

var _Spinner = require('./generic/Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

var _Constants = require('./Constants');

var Constants = _interopRequireWildcard(_Constants);

var _reactRouterDom = require('react-router-dom');

var _List = require('./List');

var _List2 = _interopRequireDefault(_List);

var _Header = require('./common/Header');

var _Header2 = _interopRequireDefault(_Header);

var _Footer = require('./common/Footer');

var _Footer2 = _interopRequireDefault(_Footer);

var _LocationDetail = require('./home/LocationDetail');

var _LocationDetail2 = _interopRequireDefault(_LocationDetail);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PICKUP = Constants.PICKUP;
var CURBSIDEPICKUP = Constants.CURBSIDEPICKUP;
var DINEIN = Constants.DINEIN;
var DELIVERY = Constants.DELIVERY;

//wrapper functional component to pass params as props to main file.
function withRouter(Component) {
    function ComponentWithRouter(props) {
        var history = (0, _reactRouterDom.useHistory)();
        var params = (0, _reactRouterDom.useParams)();
        return _react2.default.createElement(Component, _extends({}, props, { history: history, params: params /* other hooks */ }));
    }
    return ComponentWithRouter;
}

var Main = (0, _createReactClass2.default)({
    displayName: 'Main',


    mixins: [_reflux2.default.listenTo(_MainStore2.default, 'onMainStoreChange')],

    getInitialState: function getInitialState() {
        return {
            data: {
                LocationDetail: null,
                BusinessDetail: null,
                BusinessLocations: [],
                GroupDetails: [],
                ItemDetails: [],
                groupHierarchy: [],
                menuHierarchy: []
            },
            // defaultLocationActive : false,
            // defaultLocId : null,
            // loadScheduleScreen : false,
            showSpinner: true
            // search : ""
        };
    },
    UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {

        var locId = this.props.params.locId;
        var history = this.props.history;
        var location = history.location;
        // this.getAllDataAndReload(locId);
        if (!location.hasOwnProperty("resetStore")) {
            // when load the main class get all the data and reload
            // Get and load all the data
            this.getAllDataAndReload(locId);
        } else {
            var dataSet = _MainStore2.default.getMainScreenDataSet();
            // print the data
            if (!Utils.isEmptyObj(dataSet)) {
                this.updateLocationData(dataSet);
            } else {
                this.getAllDataAndReload(locId);
            }
        }
    },


    // componentDidMount() {
    //
    //     console.log("did mount")
    //
    //     let locId = null;
    //     let historyRouter = this.props.history;
    //     if (this.props.params.locId && this.props.params.locId != null) {
    //         locId = this.props.params.locId;
    //     }
    //
    //     let itemId = null;
    //     if (this.props.params.itemId && this.props.params.itemId != null) {
    //         itemId = this.props.params.itemId;
    //     }
    // },

    UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
        var _this = this;

        if (this.props.params.locId !== nextProps.params.locId) {

            var locId = nextProps.params.locId;
            // when load the main class get all the data and reload
            this.setState({
                showSpinner: true
            }, function () {
                _this.getAllDataAndReload(locId);
            });
        }
    },
    getAllDataAndReload: function getAllDataAndReload(locId) {

        // set the defaultLocationActive state true when location send on the url
        // set location id in the defaultLocId state
        if (locId && locId != null) {

            _Actions2.default.getAllData(null, locId);
        } else {
            _Actions2.default.getAllData();
        }
    },
    updateLocationData: function updateLocationData(data) {

        var activeLocationIndex = 0;
        var dataToSet = this.state.data;

        var history = this.props.history;
        var location = history.location;

        if (dataToSet.BusinessDetail === null) {
            dataToSet.BusinessDetail = data.BusinessDetail;
            var businessDetail = data.BusinessDetail;

            if (!Utils.isEmptyObj(businessDetail) && !location.hasOwnProperty("resetStore")) {
                _StyleGenerator2.default.generateGlobalStyleSheet(businessDetail.websiteConfig);
            }
        }

        if (dataToSet.BusinessLocations.length === 0) {
            dataToSet.BusinessLocations = data.BusinessLocations;
        }

        if (dataToSet.LocationDetail === null || dataToSet.LocationDetail !== null && dataToSet.LocationDetail.objectId !== data.LocationDetail.objectId) {
            dataToSet.LocationDetail = data.LocationDetail;
        }

        dataToSet.GroupDetails = data.GroupDetails;
        dataToSet.ItemDetails = data.ItemDetails;
        dataToSet.groupHierarchy = data.groupHierarchy;
        dataToSet.menuHierarchy = data.menuHierarchy;

        activeLocationIndex = this.getActiveLocationIndex(data);

        this.setState({
            data: dataToSet,
            activeLocationIndex: activeLocationIndex,
            showSpinner: false
        });
    },
    onMainStoreChange: function onMainStoreChange(event, data) {
        this.updateLocationData(data);
    },
    getActiveLocationIndex: function getActiveLocationIndex(data) {

        var index = 0;
        if (data.LocationDetail) {
            data.BusinessLocations.some(function (location, idx) {
                if (location.objectId == data.LocationDetail.objectId) {
                    index = idx;
                    return true;
                }
            });
        }
        return index;
    },
    checkRestaurantIsOpen: function checkRestaurantIsOpen() {

        // get date time based on the location
        var dateTime = _MainStore2.default.getCurrentDateTime();
        /*
        * activeLocationOpenHours should return the openHours corresponding to the selected day
        * */

        var orderTypeLocationOpenHours = _CartStore2.default.getOnlineOrderingHours();

        var isLocationOrderTypeOpen = Utils.isResturantOpen(orderTypeLocationOpenHours, dateTime);

        return isLocationOrderTypeOpen;
    },
    content: function content() {

        var locationDetail = this.state.data.LocationDetail;
        var itemDetails = this.state.data.ItemDetails;
        var businessDetail = this.state.data.BusinessDetail;
        var websiteConfig = businessDetail.websiteConfig;

        var bName = "";
        var isResturantOpen = false;

        var HeaderData = {
            LocationDetail: locationDetail
        };

        if (businessDetail) {
            bName = businessDetail.name;
        }

        if (locationDetail) {
            // get date time based on the location
            var dateTime = _MainStore2.default.getCurrentDateTime();

            isResturantOpen = Utils.isResturantOpen(locationDetail.openHours, dateTime);
        }

        if (this.props.children) {
            return _react2.default.cloneElement(this.props.children, {
                itemDetails: itemDetails,
                locationDetail: locationDetail,
                businessDetail: businessDetail
            });
        }

        HeaderData["GroupDetails"] = this.state.data.menuHierarchy;

        return _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(_LocationDetail2.default, {
                locationData: locationDetail,
                websiteConfig: websiteConfig,
                history: this.props.history,
                locId: this.props.params.locId
            }),
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_CategoryMenu2.default, {
                    categoryData: HeaderData.GroupDetails
                    // callOnFilterChange={this.onFilterChange}
                }),
                _react2.default.createElement(
                    'section',
                    { className: 'offer-dedicated-body pt-2 pb-2 mt-4 mb-4 position-relative', style: { marginTop: "-550px" },
                        id: 'menu-section' },
                    _react2.default.createElement(_List2.default, {
                        groupHierarchy: this.state.data.groupHierarchy,
                        isResturantOpen: isResturantOpen
                    })
                )
            )
        );
    },
    loadSpinner: function loadSpinner() {
        return _react2.default.createElement(_Spinner2.default, {
            disply: "block",
            classNames: "spinner-box"
        });
    },
    loadMainContent: function loadMainContent() {
        var showMainDiv = this.state && this.state.data && this.state.data.BusinessDetail && this.state.data.LocationDetail;
        return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_Header2.default, null),
            _react2.default.createElement(_Spinner2.default, null),
            showMainDiv && this.content(),
            _react2.default.createElement(_Footer2.default, null)
        );
    },
    render: function render() {
        return _react2.default.createElement(
            _react2.default.Fragment,
            null,
            this.state.showSpinner ? this.loadSpinner() : this.loadMainContent()
        );
    }
});

//create highter order component.
var HOCMAIN = withRouter(Main);

exports.default = HOCMAIN;


//////////////////
// WEBPACK FOOTER
// ./src/components/Main.jsx
// module id = 412
// module chunks = 0